const estates = [
  {
    coordinates: [-102.355209345775, 22.0125583745667],
    CVE_ENT: '01',
    NOM_ENT: 'Aguascalientes',
    POBTOT2015: 1312544,
    VHAC: 21.86,
    GME: 'Bajo'
  },
  {
    coordinates: [-115.095027015192, 30.5778432037341],
    CVE_ENT: '02',
    NOM_ENT: 'Baja California',
    POBTOT2015: 3315766,
    VHAC: 23.03,
    GME: 'Muy bajo'
  },
  {
    coordinates: [-113.683767595878, 27.3620412494335],
    CVE_ENT: '03',
    NOM_ENT: 'Baja California Sur',
    POBTOT2015: 712029,
    VHAC: 26.23,
    GME: 'Bajo'
  },
  {
    coordinates: [-89.8934555277054, 18.9783884716207],
    CVE_ENT: '04',
    NOM_ENT: 'Campeche',
    POBTOT2015: 899931,
    VHAC: 37.93,
    GME: 'Alto'
  },
  {
    coordinates: [-102.044312874341, 27.2876465767794],
    CVE_ENT: '05',
    NOM_ENT: 'Coahuila',
    POBTOT2015: 2954915,
    VHAC: 23.62,
    GME: 'Muy bajo'
  },
  {
    coordinates: [-103.784844326184, 19.0781042215698],
    CVE_ENT: '06',
    NOM_ENT: 'Colima',
    POBTOT2015: 711235,
    VHAC: 25.65,
    GME: 'Bajo'
  },
  {
    coordinates: [-93.1816622247373, 16.6794195940716],
    CVE_ENT: '07',
    NOM_ENT: 'Chiapas',
    POBTOT2015: 5217908,
    VHAC: 44.46,
    GME: 'Muy alto'
  },
  {
    coordinates: [-106.464127571201, 28.8026849557372],
    CVE_ENT: '08',
    NOM_ENT: 'Chihuahua',
    POBTOT2015: 3556574,
    VHAC: 22.16,
    GME: 'Bajo'
  },
  {
    coordinates: [-99.1394045509848, 19.2768137010608],
    CVE_ENT: '09',
    NOM_ENT: 'Ciudad de México',
    POBTOT2015: 8918653,
    VHAC: 19.19,
    GME: 'Muy bajo'
  },
  {
    coordinates: [-104.825111116081, 24.5759582391485],
    CVE_ENT: '10',
    NOM_ENT: 'Durango',
    POBTOT2015: 1754754,
    VHAC: 24.58,
    GME: 'Medio'
  },
  {
    coordinates: [-101.01329119994, 20.904471697089],
    CVE_ENT: '11',
    NOM_ENT: 'Guanajuato',
    POBTOT2015: 5853677,
    VHAC: 25.36,
    GME: 'Medio'
  },
  {
    coordinates: [-99.043081900483, 17.4281018758893],
    CVE_ENT: '12',
    NOM_ENT: 'Guerrero',
    POBTOT2015: 3533251,
    VHAC: 42.11,
    GME: 'Muy alto'
  },
  {
    coordinates: [-99.3894946720973, 20.4383281401668],
    CVE_ENT: '13',
    NOM_ENT: 'Hidalgo',
    POBTOT2015: 2858359,
    VHAC: 28.17,
    GME: 'Alto'
  },
  {
    coordinates: [-104.643067169393, 20.056848280512],
    CVE_ENT: '14',
    NOM_ENT: 'Jalisco',
    POBTOT2015: 7844830,
    VHAC: 22.12,
    GME: 'Bajo'
  },
  {
    coordinates: [-99.6060386610995, 19.4544683832781],
    CVE_ENT: '15',
    NOM_ENT: 'México',
    POBTOT2015: 1618760,
    VHAC: 28.53,
    GME: 'Bajo'
  },
  {
    coordinates: [-101.90838847822, 19.2212138233675],
    CVE_ENT: '16',
    NOM_ENT: 'Michoacán',
    POBTOT2015: 4584471,
    VHAC: 28.05,
    GME: 'Alto'
  },
  {
    coordinates: [-99.0749794009988, 18.74193259126],
    CVE_ENT: '17',
    NOM_ENT: 'Morelos',
    POBTOT2015: 1903811,
    VHAC: 27.04,
    GME: 'Medio'
  },
  {
    coordinates: [-104.839438478448, 21.8023629935256],
    CVE_ENT: '18',
    NOM_ENT: 'Nayarit',
    POBTOT2015: 1181050,
    VHAC: 27.63,
    GME: 'Medio'
  },
  {
    coordinates: [-99.8148909082887, 25.6123783219026],
    CVE_ENT: '19',
    NOM_ENT: 'Nuevo León',
    POBTOT2015: 5119504,
    VHAC: 23.09,
    GME: 'Muy bajo'
  },
  {
    coordinates: [-96.4279811490544, 16.9612935292274],
    CVE_ENT: '20',
    NOM_ENT: 'Oaxaca',
    POBTOT2015: 3967889,
    VHAC: 38.33,
    GME: 'Muy alto'
  },
  {
    coordinates: [-97.8922826580029, 18.5600474163234],
    CVE_ENT: '21',
    NOM_ENT: 'Puebla',
    POBTOT2015: 6168883,
    VHAC: 35.27,
    GME: 'Alto'
  },
  {
    coordinates: [-99.847300618942, 20.8544409751392],
    CVE_ENT: '22',
    NOM_ENT: 'Querétaro',
    POBTOT2015: 2038372,
    VHAC: 24.21,
    GME: 'Bajo'
  },
  {
    coordinates: [-88.133023305814, 19.5848832972597],
    CVE_ENT: '23',
    NOM_ENT: 'Quintana Roo',
    POBTOT2015: 1501562,
    VHAC: 36.31,
    GME: 'Medio'
  },
  {
    coordinates: [-100.306963436987, 22.480150122592],
    CVE_ENT: '24',
    NOM_ENT: 'San Luis Potosí',
    POBTOT2015: 2717820,
    VHAC: 25.21,
    GME: 'Alto'
  },
  {
    coordinates: [-108.457996585197, 26.0667927169364],
    CVE_ENT: '25',
    NOM_ENT: 'Sinaloa',
    POBTOT2015: 2966321,
    VHAC: 30.37,
    GME: 'Medio'
  },
  {
    coordinates: [-110.78083571136, 29.6891467301303],
    CVE_ENT: '26',
    NOM_ENT: 'Sonora',
    POBTOT2015: 2850330,
    VHAC: 26.63,
    GME: 'Bajo'
  },
  {
    coordinates: [-92.5922192636077, 17.939299422692],
    CVE_ENT: '27',
    NOM_ENT: 'Tabasco',
    POBTOT2015: 2395272,
    VHAC: 32.5,
    GME: 'Medio'
  },
  {
    coordinates: [-98.6424487125699, 24.2820331526013],
    CVE_ENT: '28',
    NOM_ENT: 'Tamaulipas',
    POBTOT2015: 3441698,
    VHAC: 28.69,
    GME: 'Bajo'
  },
  {
    coordinates: [-98.1678446944751, 19.3898037921157],
    CVE_ENT: '29',
    NOM_ENT: 'Tlaxcala',
    POBTOT2015: 1272847,
    VHAC: 32,
    GME: 'Medio'
  },
  {
    coordinates: [-96.3895760747806, 19.3791515243236],
    CVE_ENT: '30',
    NOM_ENT: 'Veracruz',
    POBTOT2015: 8112505,
    VHAC: 32.03,
    GME: 'Alto'
  },
  {
    coordinates: [-89.0085182849216, 20.5417181813707],
    CVE_ENT: '31',
    NOM_ENT: 'Yucatán',
    POBTOT2015: 2097175,
    VHAC: 36.42,
    GME: 'Alto'
  },
  {
    coordinates: [-101.660127044629, 22.224177903442],
    CVE_ENT: '32',
    NOM_ENT: 'Zacatecas',
    POBTOT2015: 1579209,
    VHAC: 24.99,
    GME: 'Medio'
  }
]

export default estates
